import React, { useState, useEffect, useRef } from 'react';
import i18n from '../../../../utils/ChrI18n';
import { useSelector } from '../../../../chronusStore/helper';

const SlotsInfo = ({ slotsInfo, eventId }) => {
  var label = undefined;
  const [count, setCount] = useState(slotsInfo.slotsCount);
  const prevRsvpStatus = useRef(slotsInfo.initialStatus);
  const currentRsvpStatus = useSelector(state => state.eventsListing.eventIdRsvpStatusMap[eventId]);
  if(count == 0 && slotsInfo.textForZeroCount)
    label = <div className={ slotsInfo.textForZeroCount.labelClass}> { i18n.t(slotsInfo.textForZeroCount.translationKey) } </div>;

  const translationOptions = {}
  if(slotsInfo.translationOptions)
    slotsInfo.translationOptions.forEach(translationOption => {
      translationOptions[translationOption.key] = translationOption.value;
    });

  useEffect(() => {
    if(currentRsvpStatus == slotsInfo.rsvpYes && prevRsvpStatus.current !== slotsInfo.rsvpYes){
      setCount(count => {
        if(slotsInfo.updateAction == "addition")
          return Math.min(count + 1, slotsInfo.maxSlotLimit);
        else
          return Math.max(count - 1, 0);
      });
    }
    else if(currentRsvpStatus !== undefined && currentRsvpStatus != slotsInfo.rsvpYes && prevRsvpStatus.current == slotsInfo.rsvpYes){
      setCount(count => {
        if(slotsInfo.updateAction == "addition")
          return Math.max(count - 1, 0);
        else
          return Math.min(count + 1, slotsInfo.maxSlotLimit);
      });
    }

    if(currentRsvpStatus !== undefined)
      prevRsvpStatus.current = currentRsvpStatus;
  }, [currentRsvpStatus]);

  return(
    <div className="p-t-xs">
      <div className="media-left p-r-0 pr-1">
        <i className="fa-regular fa-users fa-fw m-r-xs"/>
      </div>
      <div className={ `media-body ${slotsInfo.labelClass}` }>
        { label || i18n.t(
          slotsInfo.translationKey,
          {
            ...translationOptions,
            ...{
              [slotsInfo.slotsCountKey]: count
            }
          }
        )}
      </div>
    </div>
  );
}

export default SlotsInfo;